import { Table } from "@cofano/cck";
import { intl } from "LocaleWrapper";
import RemoveIcon from "@mui/icons-material/Remove";
import useDeclarationTable from "view/declarations/utils/useDeclarationTable";
import type { DeclarationRow } from "view/declarations/components/table/DeclarationsTable";

interface StagedDeclarationsTableProps {
	declarations: DeclarationRow[];
	onRemove: (row: DeclarationRow) => void;
};

const StagedDeclarationsTable = ({ declarations, onRemove }: StagedDeclarationsTableProps) => {

	const { getColumns } = useDeclarationTable(null);

	return (
		<Table
			id="invoices_new_staged_declarations"
			disableFooter={true}
			content={declarations}
			columns={getColumns(() => undefined, true).map(col => ({ ...col, filterComponent: undefined }))}
			rowActions={[ {
				icon: <RemoveIcon />,
				tooltip: intl.formatMessage({ id: "REMOVE_FROM_INVOICE" }),
				onClick: (row: DeclarationRow) => onRemove(row),
			} ]} />
	);
};

export default StagedDeclarationsTable;
